export class ImageAttachment {
    file: File;
    imageData: any;

    constructor(file: File = null, imageData: any = null) {
        this.file = file;
        this.imageData = imageData;
    }
}